import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Moment from 'react-moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'

class BookingPayments extends React.Component {
  state = {
    limit: 10,
    pageNumber: 0,
    list: [],
    isLoading: false,
  }

  componentDidMount() {
    this.getBookingPaymentList()
  }

  getBookingPaymentList = async () => {
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant.getAPI() + `/payment/list-payments?limit=${this.state.limit}&pageNumber=${this.state.pageNumber}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            list: res.data.data,
            isLoading: false,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'order_number',
        label: 'Order No.',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'type',
        label: 'Type of booking.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return (
              <span>
                {data == 'Chalet Booking'
                  ? 'Chalet'
                  : data == 'Store Booking'
                    ? 'Store Order'
                    : data == 'Event Booking'
                      ? 'Event'
                      : data == 'Wallet'
                        ? 'Wallet'
                        : data == 'Voucher'
                          ? 'Voucher'
                          : 'Booking'}
              </span>
            )
          },
        },
      },
      {
        name: 'payment_amount',
        label: 'Amount',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'wallet_amount_applied',
        label: 'Amount Applied from Wallet',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (data) => {
            return <span>{data || '--'}</span>
          },
        },
      },
      {
        name: 'bulkCoupon',
        label: 'Bulk Coupon Applied',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (data) => {
            return <span>{data?.coupon_code || '--'}</span>
          },
        },
      },
      {
        name: 'coupon',
        label: 'Coupon Applied',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (data) => {
            return <span>{data?.coupon_code || '--'}</span>
          },
        },
      },
      {
        name: 'payment_currency',
        label: 'Currency',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (data) => {
            return <span>{data || '--'}</span>
          },
        },
      },
      {
        name: 'createdAt',
        label: 'Payment Time',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (date) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY hh:mm A">{date}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'payment_status',
        label: 'Payment Status',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_id',
        label: 'Details',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (booking_id, { rowData }) => {
            let userId
            if (rowData[1] == 'Wallet' || rowData[1] == 'Voucher') {
              let booking = this.state.list.find((item) => item.booking_id == booking_id)

              if (booking) {
                userId = booking.created_by
              }
            }

            return (
              <div>
                {rowData[1] == 'Wallet' && (
                  <div>
                    {rowData[9] != localStorage.getItem('countryShortName') ? (
                      <div
                        onClick={() => {
                          Swal.fire({
                            title: 'Please change country according to this Entry country',
                          })
                        }}
                      >
                        <i className="f-22 icofont icofont-eye text-dark"></i>
                      </div>
                    ) : (
                      <Link
                        to={'/all-users/edit/wallet/' + userId}
                        className="m-r-15 text-muted"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title="View "
                      >
                        <i className="f-22 icofont icofont-eye text-dark"></i>
                      </Link>
                    )}
                  </div>
                )}
                {rowData[1] == 'Voucher' && (
                  <div>
                    {rowData[9] != localStorage.getItem('countryShortName') ? (
                      <div
                        onClick={() => {
                          Swal.fire({
                            title: 'Please change country according to this Entry country',
                          })
                        }}
                      >
                        <i className="f-22 icofont icofont-eye text-dark"></i>
                      </div>
                    ) : (
                      <Link
                        to={'/all-users/edit/voucher/' + userId}
                        className="m-r-15 text-muted"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-original-title="View "
                      >
                        <i className="f-22 icofont icofont-eye text-dark"></i>
                      </Link>
                    )}
                  </div>
                )}
                {rowData[1] == 'Store Booking' && (
                  <div>
                    <Link
                      to={'/store-bookings-details/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
                {rowData[1] == 'Event Booking' && (
                  <div>
                    <Link
                      to={'/new-evt/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
                {rowData[1] == 'Cruise Booking' && (
                  <div>
                    <Link
                      to={'/booking-ordering/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
                {rowData[1] == 'Chalet Booking' && (
                  <div>
                    <Link
                      to={'/chalet-booking-details/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
              </div>
            )
          },
        },
      },
    ]

    const options = {
      // filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            list: [],
          },
          () => {
            this.getBookingPaymentList(this.state.limit, currentPage)
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            list: [],
          },
          () => {
            this.getBookingPaymentList(numberOfRows, this.state.pageNumber)
          }
        )
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Payments</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Booking Payments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Booking Payments'}
                          className="table-responsive"
                          data={this.state.list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BookingPayments
